jQuery(document).ready(function($) {

	// Toggles the logo image depending on if it's a fixed or floating header

	const mainHeader = $('#main-header')
	const mainLogo = mainHeader.find('#logo');

	const toggleImage = function(targetNode) {
		if (targetNode.hasClass('et-fixed-header')) {
			mainLogo.attr('src', '/wp-content/uploads/sites/4/2022/10/Sheriff-Assist-NYSSI-lockup.png');
		} else {
			mainLogo.attr('src', '/wp-content/uploads/sites/4/2022/10/Sheriff-Assist-icon.png');
		}
	}
	toggleImage(mainHeader);

	const observer = new MutationObserver(function(mutationList, observer) {
		mutationList.forEach(function(mutation) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				toggleImage(mainHeader)
			}
		})
	});
	observer.observe(mainHeader[0], { attributes: true });
}); 